import { isTypeTestimonialSection } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulTestimonialSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeTestimonialSection(entry)) {
    return null;
  }

  return <div>ContentfulTestimonialSection</div>;
};

export default ContentfulTestimonialSection;
